<template>
  <!--    data-area-start-->
  <div class="data-area" :style="'background-image: url(' + article.images.url + ')'">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="data-cntaint">
            <div class="data-title">
              <h3>{{ article.title }}</h3>
              <p>
                {{ article.subTitle }}
              </p>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="single-data">
                  <p v-html="article.text"></p>
                </div>
              </div>
            </div>
            <div class="data-btn">
              <a :href="buttonLink" class="theme-btn">{{buttonText}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    data-area-end-->
</template>

<script>
import { getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';
// TODO: Put in Strapi

export default {
  created() {
    getArticleById(this.articleId).then(res => {
      this.article = translate(res);
    });
  },
  props: {
    articleId: {
      type: String
    },
    buttonText: {
      type: String,
      default: 'Fill the form'
    },
    buttonLink: {
      type: String,
      default: '/digitalleaders/form2'
    }
  },
  data() {
    return {
      article: {
        images: ''
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
